import styled from 'styled-components';

const StyledActionSection = styled.div``;

export default StyledActionSection;
